import type { CorePlanTier } from "@functions/plans/types";
import type { WorkspaceUsage } from "@functions/state/types";
import { getPlanPricing } from "../../../../../clientServices/workspaceFeaturesCredits";
import { fetchCheckoutUrlAndRedirect } from "../../../../../backendapi/workspaceApi";
import { buildPaidPlanCheckoutPayload } from "./checkoutPayload";

type ProjectSelector = Parameters<typeof getPlanPricing>[0];

export type OpenCoreTierCheckoutArgs = {
    usage: WorkspaceUsage | null | undefined;
    uid: string | undefined;
    tier: CorePlanTier;
    isAnnual: boolean;
    projectSelector: ProjectSelector;
    source?: string;
    seatAddonQuantity?: number;
    successUrl?: string;
};

export async function openCoreTierCheckout({
    usage,
    uid,
    tier,
    isAnnual,
    projectSelector,
    source,
    seatAddonQuantity = 0,
    successUrl
}: OpenCoreTierCheckoutArgs): Promise<void> {
    const interval = isAnnual ? "annually" : "monthly";
    const tierPrice = isAnnual ? tier.annualPrice : tier.monthlyPrice;
    const totalPrice = `$${isAnnual ? tierPrice * 12 : tierPrice}`;
    const corePricing = getPlanPricing(projectSelector).core[interval];

    const payload = buildPaidPlanCheckoutPayload({
        workspaceId: usage?.id,
        uid,
        planType: "core",
        funnelSource: source,
        priceId: corePricing.priceId,
        price: totalPrice,
        interval,
        seatAddonQuantity,
        successUrl,
        tierCredits: tier.credits
    });

    await fetchCheckoutUrlAndRedirect(payload);
}
